(function () {
    "use strict";
    angular
        .module("skillBuilderSaaS")
        .controller("InventoryAssignModalCtrl", ["orderItemInventoryResource", "messageService", "$state", "$http", inventoryAssignModalCtrl]);
    function inventoryAssignModalCtrl(orderItemInventoryResource, messageService, $state, $http) {
        var vm = this;
        vm.name = "";
        vm.productId = $state.params.productId;
        vm.available = $state.params.available;
        vm.assignToOrganization = $state.params.assignToOrganization;
        vm.assignTo = "Email";
        vm.saving = false;
        vm.getOrganizationMembers = function (val) {
            return $http.get("api/account/my-organization-member-list/" + val).then(function (result) {
                return result.data;
            });
        };
        vm.onSelect = function (member) {
            vm.selectedMember = member;
            vm.email = member.email;
        };
        vm.assign = function () {
            if (vm.form.$valid) {
                if (vm.busy)
                    return;
                vm.busy = true;
                var id = vm.selectedMember ? vm.selectedMember.id : "";
                orderItemInventoryResource.assign({ type: vm.assignTo, productId: vm.productId, email: vm.email, userId: id }, function () {
                    $state.go("main.accountInventory", {}, { reload: true });
                }, function (error) {
                    vm.busy = false;
                    messageService.error(error);
                    $state.go("main.accountInventory", {}, { reload: true });
                });
            }
            else {
                vm.showErrors = true;
            }
        };
    }
}());
